import React from 'react';
import Loadable from 'react-loadable';
var Webform = Loadable({
  loader: function loader() {
    return import('./index.lazy');
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement("div", null);
  }
});
export default Webform;